import React, { useState } from 'react';

import FullLogo from '../assets/full-logo.svg';
import { ReactComponent as ArrowBack } from '../assets/arrow-back.svg';
import { ReactComponent as BoxShape } from '../assets/box-shape.svg';

import Spinner from '../components/Spinner';
import { OwnerLoginStage } from '../helpers/EnumsInternal';
import OwnerConsentsFind from '../components/ownerConsents/OwnerConsentsFind';
import OwnerConsentsSendCode from '../components/ownerConsents/OwnerConsentsSendCode';
import OwnerExternRefresh from '../components/ownerConsents/OwnerExternRefresh';
import OwnerFooter from '../components/OwnerFooter';
import NotReadyPage from './NotReadyPage';


function OwnerLoginPage() {
    const [spinner, showSpinner] = useState<boolean>(false);
    const [ownerLoginStage, setOwnerLoginStage] = useState<OwnerLoginStage>(OwnerLoginStage.Start);
    const [loginCodeId, setLoginCodeId] = useState<number>(0);
    const [inputMobileOrEmail, setInputMobileOrEmail] = useState<string>('');


    return (
        <>
            { window.location.hostname.match(/^app.mitsamtykke.dk$/) ?
                <NotReadyPage />
            :
                ownerLoginStage !== OwnerLoginStage.Refresh ?
                    <div className="login-container login-consentowner">
                        { spinner && <Spinner /> }
                        <div className="content">
                            <div className="top d-flex align-items-center justify-content-between">
                                <a className="logo" href="https://www.mitsamtykke.dk/"><img src={FullLogo} alt="Logo" /></a>
                                { ownerLoginStage > OwnerLoginStage.Start &&
                                    <div className="d-flex link-back" onClick={() => setOwnerLoginStage(OwnerLoginStage.Start)}><ArrowBack />Start forfra</div>
                                }
                            </div>
                                    
                            <div className="login-area">
                                <div className="inner">
                                    <h1>Find dine samtykker</h1>
                                    <p>Indtast dit telefonnummer eller e-mail herunder, for at se hvilke markedsføringssamtykker du har afgivet på dem.</p>

                                    <div className="form-w-steps">

                                        <div className="nav">
                                            <div className={ 'step-nav ' + (!ownerLoginStage ? 'active' : 'pointer') }
                                                onClick={ () => { if (ownerLoginStage > OwnerLoginStage.Start ) setOwnerLoginStage(OwnerLoginStage.Start); } } >
                                                <div className="number"><BoxShape />1</div>
                                                    <p>Indtast telefon eller e-mail</p>
                                                </div> 

                                            <div className={ 'step-nav' + (ownerLoginStage === OwnerLoginStage.Code ? ' active' : '') }>
                                                <div className="number"><BoxShape />2</div>
                                                <p>Indtast tilsendt verificeringskode</p>
                                            </div>
                                        </div>

                                        { ownerLoginStage === OwnerLoginStage.Start && <OwnerConsentsFind setInputMobileOrEmail={setInputMobileOrEmail} showSpinner={showSpinner}
                                            setOwnerLoginStage={setOwnerLoginStage} setLoginCodeId={setLoginCodeId} />}
                                        { ownerLoginStage === OwnerLoginStage.Code && <OwnerConsentsSendCode inputMobileOrEmail={inputMobileOrEmail} showSpinner={showSpinner}
                                            setOwnerLoginStage={setOwnerLoginStage} loginCodeId={loginCodeId} />}
                                    </div>

                                    <div className="terms">
                                        <p>MitSamtykke er til for DIT samtykkes skyld. Se vores brugsbetingelser <a href="https://www.mitsamtykke.dk/brugervilkaar/" target="_blank" rel="noopener noreferrer">her</a></p>
                                    </div>
                                </div>
                            </div>

                            <OwnerFooter />
                        </div>
                        <div className="image-container"></div>
                    </div>
                :
                    ownerLoginStage === OwnerLoginStage.Refresh && <OwnerExternRefresh inputMobileOrEmail={inputMobileOrEmail}
                        setOwnerLoginStage={setOwnerLoginStage} loginCodeId={loginCodeId} />
            }
        </>
    );
}

export default OwnerLoginPage